import React, { useEffect, useState } from "react";
import { notify } from "../../components/Common/Alerts";
import Utils from "../../utils";
import { decryptData } from "../../utils/crypto";
import { useConfig } from "../../components/Context/ConfigContext";

const CustomerPage = () => {
  const steps = [
    "Turn on location and instantly discover nearby stores",
    "Select your preferred store and explore category-wise products",
    "Add items to cart and place order – no upfront payment required",
    "Get instant confirmation and real-time order updates",
    "Choose pickup or delivery as per your convenience",
    "Pay easily at the store (Cash / Online) at the time of order collection",
  ];

  const features = [
    "No Advance Payment – Order first, pay later",
    "Nearby Store Discovery – Fast and location-based results",
    "Real-Time Notifications – Stay updated at every step",
    "Flexible Fulfillment – Pickup or Delivery options",
    "Simple & User-Friendly Experience",
  ];
  const { configData } = useConfig();



  return (
    <div className="min-h-screen bg-zinc-50 dark:bg-slate-950 px-4 py-8">
      <div className="max-w-5xl mx-auto space-y-10">
        {/* HEADER */}
        <div className="text-center space-y-3">
          <h1 className="text-3xl md:text-4xl font-black text-zinc-900 dark:text-white">
            👤 Shop Smart with Dukansetu
          </h1>
          <p className="text-sm md:text-base text-zinc-600 dark:text-slate-400 max-w-2xl mx-auto">
            With Dukansetu, you can easily discover nearby stores based on your
            location, explore a wide range of products category-wise, and place
            orders without any advance payment.
          </p>
        </div>

        {/* DESCRIPTION */}
        <div className="bg-white dark:bg-slate-900 rounded-3xl p-6 md:p-8 shadow-md border border-zinc-200 dark:border-slate-800">
          <p className="text-sm md:text-base text-zinc-600 dark:text-slate-300 leading-relaxed">
            The platform is designed to give you a smooth, reliable, and
            flexible shopping experience where you can order first and pay later
            at the store.
          </p>
          <p className="mt-4 text-sm md:text-base text-zinc-600 dark:text-slate-300 leading-relaxed">
            Whether you prefer quick pickup or convenient delivery, Dukansetu
            connects you directly with local stores, ensures real-time updates
            on your orders, and makes the entire process simple, fast, and
            hassle-free.
          </p>
        </div>

        {/* HOW IT WORKS */}
        <div>
          <h2 className="text-xl font-black text-blue-600 mb-6">
            ⚙️ How it Works
          </h2>

          <div className="grid gap-4">
            {steps.map((step, i) => (
              <div
                key={i}
                className="bg-white dark:bg-slate-900 border border-zinc-200 dark:border-slate-800 rounded-2xl p-5 shadow-sm hover:shadow-md transition"
              >
                <div className="flex gap-4">
                  <div className="min-w-[36px] h-[36px] flex items-center justify-center rounded-xl bg-blue-500 text-white font-bold">
                    {i + 1}
                  </div>

                  <p className="text-sm text-zinc-600 dark:text-slate-300 font-medium">
                    {step}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* FEATURES */}
        <div>
          <h2 className="text-xl font-black text-green-600 mb-6">
            🚀 Key Features
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {features.map((feature, i) => (
              <div
                key={i}
                className="bg-white dark:bg-slate-900 border border-zinc-200 dark:border-slate-800 rounded-2xl p-5 text-sm font-semibold text-zinc-700 dark:text-slate-300 shadow-sm hover:shadow-md transition"
              >
                ✔ {feature}
              </div>
            ))}
          </div>
        </div>

        {/* WHY */}
        <div className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-3xl p-6 md:p-8 shadow-xl">
          <h2 className="text-xl font-black mb-3">Why Dukansetu?</h2>
          <p className="text-sm md:text-base opacity-90 leading-relaxed">
            Dukansetu connects you directly with nearby trusted stores, making
            your shopping faster, easier, and more reliable — without any
            payment stress.
          </p>
        </div>
        <div className="mt-10 text-center">
          <p className="text-sm text-zinc-500 dark:text-slate-400">
            For any queries, contact us at{" "}
            <a
              href={`mailto:${configData?.support_email}`}
              className="text-orange-500 font-semibold hover:underline"
            >
              {configData?.support_email}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CustomerPage;
